module.exports = __webpack_public_path__ + "img/zoe_estates_bg_012.71767c28.jpg";